<template lang="pug">
  section.header__container
    .header__content
      .header__title ODIN
      .user-info__container(
        v-if="$route.name !== 'Auth'"
      )
        the-account
</template>

<script>
import TheAccount from '../TheAccount.vue';

export default {
  name: 'TheHeader',

  components: {
    TheAccount,
  },
};
</script>

<style lang="scss" scoped>
  .header__container {
    width: 100%;
    height: 56px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.16);
    background-color: #fff;

    @include mobile {
      height: 60px;
    }
  }

  .header__title {
    font-family: Roboto;
    font-size: 24px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.67px;
    color: #000000;
  }

  .header__content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1200px;
    margin: 0 auto;
    height: 56px;
    min-width: 280px;

    @include tablet {
      margin-left: 16px;
      margin-right: 16px;
    }

    @include mobile {
      height: 60px;
      margin-left: 20px;
      margin-right: 20px;
    }
  }

  .user__icon {
    display: none;

    @include mobile {
      display: block;
    }
  }

  .user__name {
    @include mobile {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/TheHeader.vue